import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
const STORAGE_KEY_REDIRECT = 'redirectUrl';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public auth: IdentityAuthService, public router: Router,
    @Inject(LOCAL_STORAGE) private storage: StorageService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    //debugger;
    //if (!this.auth.AppSettingsLoaded) {
    //  this.auth.appSettingsLoadedEvent.subscribe(loaded => {
    //    if (loaded)
    //      return this.auth.isAuthenticated()
    //  })
        
    //}
    //else {
    //  if (this.auth.isAuthenticated())
    //    return true;
    //}
    if (this.auth.AppSettingsLoaded && !this.auth.isAuthenticated()) {
      ///this.storage.set(STORAGE_KEY_REDIRECT, this.router.url);
      this.auth.login();
      return false;
    }
    return true;
  }
}
